import { ISecondaryPhysician } from '~/services/api/attendingPhysicians/types';

const getPhysicianInitialValues = (physician: ISecondaryPhysician): ISecondaryPhysician => ({
  ...physician,
  id: physician.id ?? 0,
  name: physician.name ?? '',
  phone: physician.phone ?? '',
  fax: physician.fax ?? '',
  specialty: physician.specialty ?? '',
});

export default getPhysicianInitialValues;
